import { useMemo, useCallback } from "react";
import { useMutation } from "react-query";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useToast } from "../../../../hooks/useToast";
import { Dialog } from "../../../../components/Dialog";
import { Group } from "../../../../types/whatsapp";
import { ButtonProps } from "@mui/material/Button";
import { updateGroups } from "../../../../services/whatsapp";

type DialogEditProps = {
  open: boolean;
  group?: Group;
  onClose: () => void;
  onSave?: () => void;
};

const VALIDATION_SCHEMA = Yup.object().shape({
  name: Yup.string().required("Informe o nome"),
  image: Yup.string().notRequired(),
});

function DialogEdit({ open, group, onClose, onSave }: DialogEditProps) {
  const toast = useToast();

  const handlePutGroup = useMutation(
    async (data: any) => {
      const response = await updateGroups(data);
      return response;
    },
    {
      onSuccess: () => {
        if (onSave) onSave();
        onClose();
        toast.show("Grupo editado com sucesso!", { severity: "success" });
      },
      onError: () => {
        toast.show("Não foi possível editar o grupo.", { severity: "error" });
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      name: group?.NAME,
      image: group?.IMAGE,
      client: group?.INSTANCE,
      id: group?.ID,
    },
    onSubmit: () => {},
    validationSchema: VALIDATION_SCHEMA,
    validateOnBlur: true,
  });

  const handleUpdate = useCallback(async () => {
    try {
      await handlePutGroup.mutateAsync(formik.values);
    } catch (err) {
      console.log(err);
    }
  }, [formik.values, handlePutGroup]);

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Cancelar",
        onClick: onClose,
        disabled: handlePutGroup.isLoading,
        color: "inherit",
        size: "small",
      },
      {
        children: handlePutGroup.isLoading ? "Editando" : "Editar",
        onClick: handleUpdate,
        disabled: handlePutGroup.isLoading,
        color: "primary",
        variant: "contained",
        size: "small",
      },
    ];
  }, [handlePutGroup.isLoading, onClose, handleUpdate]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      title={group?.NAME}
      onClose={onClose}
      actions={actions}
    >
      <Stack pt={2} spacing={2} justifyContent="center">
        <TextField
          label="Nome"
          value={formik.values.name}
          size="small"
          fullWidth
          onChange={formik.handleChange("name")}
        />
        {/* <Button
          startIcon={<UploadIcon />}
          disableElevation
          variant="contained"
          component="label"
        >
          Escolher imagem
          <input hidden accept="image/*" multiple type="file" />
        </Button> */}
      </Stack>
    </Dialog>
  );
}

export default DialogEdit;
